/**
 * _extrasImages.ts — Galerías Unsplash verificadas para la categoría Extras.
 *
 * Solo IDs que responden 200 (mismo pool verificado que Desayuno).
 */
const u = (photoId: string): string =>
  `https://images.unsplash.com/photo-${photoId}?w=400&h=400&fit=crop&auto=format&q=70`;

const gallery = (...ids: string[]): string[] => ids.map(u);

/** Índice alineado con cat_extra_0 … cat_extra_17 */
export const EXTRAS_GALERIA_BY_INDEX: string[][] = [
  gallery(
    "1497534446932-c925b458314e",
    "1551218808-94e220e084d2",
    "1546069901-ba9599a7e63c",
  ),
  gallery(
    "1550583724-b2692b85b150",
    "1497534446932-c925b458314e",
    "1551218808-94e220e084d2",
  ),
  gallery(
    "1509440159596-0249088772ff",
    "1598373182133-52452f7691ef",
    "1565299507177-b0ac66763828",
  ),
  gallery(
    "1509440159596-0249088772ff",
    "1598373182133-52452f7691ef",
    "1555939594-58d7cb561ad1",
  ),
  gallery(
    "1551218808-94e220e084d2",
    "1546069901-ba9599a7e63c",
    "1504674900247-0877df9cc836",
  ),
  gallery(
    "1565299507177-b0ac66763828",
    "1546069901-ba9599a7e63c",
    "1504674900247-0877df9cc836",
  ),
  gallery(
    "1550583724-b2692b85b150",
    "1565299507177-b0ac66763828",
    "1546069901-ba9599a7e63c",
  ),
  gallery(
    "1607623814075-e51df1bdc82f",
    "1555939594-58d7cb561ad1",
    "1568901346375-23c9450c58cd",
  ),
  gallery(
    "1547592166-23ac45744acd",
    "1580554530778-ca36943938b2",
    "1546069901-ba9599a7e63c",
  ),
  gallery(
    "1555939594-58d7cb561ad1",
    "1568901346375-23c9450c58cd",
    "1607623814075-e51df1bdc82f",
  ),
  gallery(
    "1546069901-ba9599a7e63c",
    "1580554530778-ca36943938b2",
    "1509440159596-0249088772ff",
  ),
  gallery(
    "1546069901-ba9599a7e63c",
    "1551218808-94e220e084d2",
    "1509440159596-0249088772ff",
  ),
  gallery(
    "1551218808-94e220e084d2",
    "1546069901-ba9599a7e63c",
    "1497534446932-c925b458314e",
  ),
  gallery(
    "1550583724-b2692b85b150",
    "1546069901-ba9599a7e63c",
    "1551218808-94e220e084d2",
  ),
  gallery(
    "1555939594-58d7cb561ad1",
    "1546069901-ba9599a7e63c",
    "1509440159596-0249088772ff",
  ),
  gallery(
    "1555939594-58d7cb561ad1",
    "1546069901-ba9599a7e63c",
    "1547592166-23ac45744acd",
  ),
  gallery(
    "1551218808-94e220e084d2",
    "1546069901-ba9599a7e63c",
    "1509440159596-0249088772ff",
  ),
];
